fragment AvailabilityReportDaySnapshotFragment on AvailabilityImpression {
    isBookable
    daysFromView
    date
    score
    averageSlots
    dataTip
}
